import { render } from "./SOP.vue?vue&type=template&id=7c55a686&scoped=true"
import script from "./SOP.vue?vue&type=script&lang=js"
export * from "./SOP.vue?vue&type=script&lang=js"

import "./SOP.vue?vue&type=style&index=0&id=7c55a686&scoped=true&lang=css"

import exportComponent from "/home/pewholesaleinnovelapp/wholesale.fresherproduce.ca/releases/81914199/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c55a686"]])

export default __exports__